import * as Sentry from '@sentry/nextjs';

const HTTP_TIMEOUT = parseInt(
  process.env.NEXT_PUBLIC_HTTP_CLIENT_TIMEOUT || '10000',
);

export async function fetchJSON<T = any>(
  input: string | URL,
  init: RequestInit,
): Promise<T> {
  Sentry.addBreadcrumb({
    category: 'http',
    message: `started ${init.method} - ${input}`,
    level: 'info',
  });

  const start = Date.now();

  let url;
  let error = null;
  let resp = null;

  try {
    url = new URL(input);
  } catch (e) {
    throw new Error(`${input} is not a valid URL`, { cause: e });
  }

  try {
    if (init.method !== 'POST') {
      // apply timeout only for modern browsers
      if (AbortSignal && AbortSignal.timeout) {
        init.signal = AbortSignal.timeout(HTTP_TIMEOUT);
      }
    }

    resp = await fetch(url, init);
  } catch (e) {
    error = new Error(`[http] call failed`, { cause: e });
  } finally {
    Sentry.addBreadcrumb({
      category: 'http',
      message: `finished ${init.method} - ${input} - duration: ${
        Date.now() - start
      }`,
      level: error !== null ? 'error' : 'info',
    });
  }

  if (error) {
    throw error;
  }

  return (await resp?.json()) as T;
}
